module.exports = __webpack_public_path__ + "img/ic_no_education_history.c7a14cae.svg";